import React, {Suspense} from 'react'
import * as UI from '@/src/(pages)/testing/ui/functional-testing-screen.styled'
import {LoadingContentPage} from '@/src/shared/ui/layout/ui/loading-content-page'

// TODO: типизировать promise
export const FunctionalTestingContent = ({promise}: {promise: Promise<any>}) => {
  return (
    <Suspense fallback={<LoadingContentPage />}>
      <ServerRenderHTML promise={promise} />
    </Suspense>
  )
}

const ServerRenderHTML = async ({promise}: {promise: Promise<any>}) => {
  const {html: nodes} = await promise

  return <UI.Static>{nodes}</UI.Static>
}
